/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {ProfileRecord} from '../models/ProfileRecord';

export interface GetAccessRightsProfiles$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccessRightsProfilesRequest = createAction<PayloadData<void>>('GET_ACCESS_RIGHTS_PROFILES__GET_ACCESS_RIGHTS_PROFILES__REQUEST');
export const getAccessRightsProfilesSuccess = createAction<PayloadData<Array<ProfileRecord>>>('GET_ACCESS_RIGHTS_PROFILES__GET_ACCESS_RIGHTS_PROFILES__SUCCESS');
export const getAccessRightsProfilesFailure = createAction<PayloadData<Error, void, true>>('GET_ACCESS_RIGHTS_PROFILES__GET_ACCESS_RIGHTS_PROFILES__FAILURE');

export const getAccessRightsProfilesActions = [
    getAccessRightsProfilesRequest,
    getAccessRightsProfilesSuccess,
    getAccessRightsProfilesFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccessRightsProfiles = (config?: GetAccessRightsProfiles$Config) => {
    return {
        CALL_API: {
            types: getAccessRightsProfilesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/admins/profiles`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

